// Add your custom JS here.

jQuery(window).load(function() {
    (function(e) {
        var d = e(".isi--drawer-wrap"),
            i = e(".isi--drawer"),
            g, j, b, f;

        function a() {
            var k = window.pageYOffset,
                l = window.innerHeight
            open();
            g = d.offset().top;
            j = b;
            close();
            f = k + l - b;
            d.height(j);
        }

        function close(k) {
            e(i).css({
                position: "fixed",
                bottom: 0
            });
            i.addClass("is-active");
            b = i.innerHeight();
            if (k) {
                e(".spotlight-link-inactive").hide();
                e(".spotlight-link-active").show();
            }
        }

        function open(k) {
            e(i).css({
                position: "relative",
                bottom: "auto"
            });
            i.removeClass("is-active");
            b = i.outerHeight(true);
            if (k) {
                e(".spotlight-link-active").hide();
                e(".spotlight-link-inactive").show();
            }
        }
        e("body").on("spotlightheight", function() {
            if (e(".isi--drawer").length && !i.hasClass("spotlight-disabled")) {
                a();
                if (g > f || e(window).scrollTop() === 0) {
                    close(true);
                } else {
                    open(true);
                }
            }
        });

        e(window).scroll(function() {
            e("body").trigger("spotlightheight");
        });
        e(window).resize(function() {
            e("body").trigger("spotlightheight");
        });

        e(".isi--drawer__button").click(function(k) {
            k.preventDefault();
            if (i.hasClass("is-active")) {
                e(window).scrollTop(g);
            } else {
                // onResizeAdjust();
                e(window).scrollTop(0);
            }
        });
    

        e("body").trigger("spotlightheight");
        
        var hash = window.location.hash;
        if(hash==='#important-safety-information' || hash==='#isi'){
            console.log('before timeout')
            setTimeout(function(){
                console.log('inside timeout')
                var aTag0 = e("#important-safety-information");
                e('html,body').animate({scrollTop: aTag0.offset().top},'fast');
            }, 600);
        }
        

        e(".download-list-item").on('click', function(event){
            var link = e(this).find('.download-list-item-link a').attr('href');
            window.open(link);
        });


        // isi preview adjust height for responsiveness

        function adjustIsiPreview(lines) {
            if (i.hasClass("is-active")) {
                var $drawerPreview = e('.isi-preview-content');
                var $topOfPreview = e('.isi-preview-content .top-line');
                var $anchor = e('#start-preview');
                if ($drawerPreview.length && $anchor.length) {
                    var anchorPosition = $anchor.position().top;
                    var previewTop = $topOfPreview.position().top;
                    var lineHeight = parseInt($drawerPreview.css('font-size'));
                    var spaceBelowAnchor = anchorPosition - previewTop + lineHeight * lines;
                    $drawerPreview.height(spaceBelowAnchor + 2);
                }
            }
        }

        function onResizeAdjust() {
            if (e(window).width() >= 992) {
                adjustIsiPreview(1);
            } else {
                adjustIsiPreview(4);
            }
        }

        onResizeAdjust();

        var resizeTimer;
        e(window).resize(function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(onResizeAdjust, 250);
        });


        //fix for drop down menu on ipad(sub menu not closing when tapping anywhere on page).
        // e('*').click(function(e) {
        //     if(bowser.ipad) {
        //         e('#navigation .nav .sub-menu').attr('display','none');
        //     }
        // });

        //mobile menu
        // e(".menu-toggle").click(function() {
        //     e(".mobile-menu").toggleClass('open');
        //     e("body").toggleClass('nav-open');
        // });

        // e(".closebtn").click(function() {
        //     e(".mobile-menu").removeClass('open');
        //     e("body").removeClass('nav-open');
        // });	

        //add arrow to nav items w submenu
        // if ( e('.mobile-nav li').hasClass('menu-item-has-children') ) {
        //     e('.mobile-nav li.menu-item-has-children').append('<span class="menu-arrow"></span>');
        // }
        //toggle submenus
        // e('.menu-arrow').on('click', function() {
        //     if(!e(this).parent().hasClass('expanded')){
        //         e('.mobile-nav li.menu-item-has-children').removeClass('expanded');
        //         e('span.menu-arrow').removeClass('rotate');
        //         e(this).parent().addClass('expanded');
        //         e(this).addClass('rotate');
        //     } else {
        //         e(this).parent().toggleClass('expanded');
        //         e(this).toggleClass('rotate');
        //     }
        // });    

        // Capture accordion open & close states.
        // e('.collapse').on('shown.bs.collapse', function(){
        //     e(this).parent().find('.panel-heading').removeClass('nohover');
        //     e(this).parent().find('.panel-heading').addClass('active');
        //     e(this).parent().find(".glyphicon-plus-sign").removeClass("glyphicon-plus-sign").addClass("glyphicon-minus-sign");
        // }).on('hidden.bs.collapse', function(){
        //     e(this).parent().find('.panel-heading').removeClass('active');
        //     e(this).parent().find(".glyphicon-minus-sign").removeClass("glyphicon-minus-sign").addClass("glyphicon-plus-sign");
        //     e(this).mouseleave();
        //     e(this).parent().find('.panel-heading').addClass('nohover');
        // });  
        
        
        e('.hamburger').on('click', function () {
            e(this).toggleClass('is-active');
            e('body').toggleClass('menu-is-active');
        });


        
        // menu dropdowns
        e('.dropdown-toggle.nav-link').on('click', function (event) {
            window.location = e(this).attr('href');
        });
        e('.dropdown-toggle.nav-link ~ span').on('click', function (event) {
            // console.log('arrow')
            // if (e(window).width() <= 768) {}
                if(e(this).hasClass('arrow-opened')){
                    e(this).removeClass('arrow-opened');
                    e('.dropdown-menu.show').removeClass('show');
                }else{
                    e('.arrow-opened').removeClass('arrow-opened');
                    e(this).addClass('arrow-opened');

                    e('.dropdown-menu.show').removeClass('show');
                    e(this).parent().find('.dropdown-menu').addClass('show');
                }
                
                event.preventDefault();
                event.stopPropagation();
            
        });
        e(window).resize(function() {
            if (e(window).width() >= 768) {
                e('.dropdown-menu.show').removeClass('show');
                e('.arrow-opened').removeClass('arrow-opened');
            }
        });




        // isi link
        // e('.menu-item-1294 > a').on('click', function(event){
        //     open(true);
        //     var aTag = e("#isi-anchor");
        //     e('html,body').animate({scrollTop: aTag.offset().top},'slow');
        //     event.preventDefault();
        // });
        e('.menu-item-1294 > a').on('click', function(event){
            event.preventDefault();
            open(true);
            var aTag = e("#important-safety-information");
            e('html,body').animate({scrollTop: aTag.offset().top},'slow');
        });
        e('.menu-item-1341 > a').on('click', function(event){
            event.preventDefault();
            open(true);
            var aTag = e("#important-safety-information");
            e('html,body').animate({scrollTop: aTag.offset().top},'slow');
        });
        e('.menu-item-1347 > a').on('click', function(event){
            event.preventDefault();
            open(true);
            var aTag = e("#important-safety-information");
            e('html,body').animate({scrollTop: aTag.offset().top},'slow');
        });
        setTimeout(function(){
            var hash = window.location.hash.substr(1);
            if(hash==='important-safety-information'){
                open(true);
                var aTag = e("#important-safety-information");
                e('html,body').animate({scrollTop: aTag.offset().top},'slow');
            }
        },100);



        e('.advgb-tab-body-header').on('click', function(event){
            // on mobile make sure its visible
            if (e(window).width() <= 768) {
                e('html,body').animate({scrollTop: e(this).offset().top},'fast');
            }
        });





        e('.isi-after-content').appendTo(e(e('.isi-after-wrapper')))
        var $select = e('select');
        $select.on('change', function(ev) {
            if(this.value!=''){
                $select.addClass('WAS-SELECTED');
            }else{
                $select.removeClass('WAS-SELECTED');
            }
            
        });

        e('.cover-hero').attr('id', 'content');


        // open popup 
        // var hcpURL = 'https://www.fotivdahcp.com';//
        // var patientURL = 'https://www.fotivda.com';
        // // var hcpURL = 'http://localhost';
        // if(window.location.origin=='https://fotivdahcp_v2.guidemarkhealth.com'){
        //     hcpURL = 'https://www.fotivdahcp.com';
        // }

        // if(window.location.hash==="#b" || e('.DISABLE-INTERSTITIAL').length>0){
        //     window.location.hash = '';
        //     sessionStorage.setItem('branch', (window.location.origin===hcpURL ? 'hcp': 'patient'));
        // }

        // var branch = sessionStorage.getItem('branch');
        // var branchLoc = true;
        // console.log(patientURL,'===',window.location.origin,' && ',branch!=='patient')
        // if(patientURL===window.location.origin && branch!=='patient'){
        //     // console.log(1)
        //     branchLoc = false;
        // }
        // if(hcpURL===window.location.origin && branch!=='hcp'){
        //     // console.log(2)
        //     branchLoc = false;
        // }

        // if(!branch || !branchLoc){
        //     e('#branchModel').modal({backdrop:'static', keyboard:false})
        //     e('#hcp-select-btn').on('click', function () {
        //         sessionStorage.setItem('branch', 'hcp');
        //         if(window.location.origin !== hcpURL){
        //             window.location = hcpURL+'/#b';
        //         }else{
        //             e('#branchModel').modal('hide');
        //         }
        //     });
        //     e('#patient-select-btn').on('click', function () {
        //         sessionStorage.setItem('branch', 'patient');
                
        //         if(window.location.origin !== patientURL){
        //             window.location = patientURL+'/#b';
        //         }else{
        //             e('#branchModel').modal('hide');
        //         }
        //     });
        // }



        // trigger animations on scroll in view
        var $animation_elements = e('.animation-element');
        var $window = e(window);
        function check_if_in_view() {
            var window_height = $window.height();
            var window_top_position = $window.scrollTop();
            var window_bottom_position = (window_top_position + window_height);
            
            e.each($animation_elements, function() {
                var $element = e(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);
            
                //check to see if this current container is within viewport
                if ((element_bottom_position >= window_top_position) &&
                    (element_top_position <= window_bottom_position)) {
                $element.addClass('in-view');
                } else {
                $element.removeClass('in-view');
                }
            });
        }
        $window.on('scroll', check_if_in_view);
        $window.trigger('scroll');


        // ani trigger gallery popup
        e('.km-click').on('click', function(){
            console.log('HELLO', e('.km-curve-gallery .cboxElement'));
            e('.km-curve-gallery .cboxElement').trigger('click');
            
        })


        // scale on resize
        var $wrapper = e(".max-wrapper");
        var $el = $wrapper.find('.max-wrapper-child');//.children(':first');
        var elHeight = $el.outerHeight();
        var elWidth = $el.outerWidth();
        function doResize(event, ui) {
            var scale, origin;
            // scale = Math.min(
            //     ui.size.width / elWidth,    
            //     ui.size.height / elHeight
            // );
            scale = ui.size.width / elWidth;

            var dimensions = $wrapper.attr('data-dimensions');
            var dimensionsH;
            var scaledHeight = 'auto';
            if(dimensions){
                dimensions = dimensions.split(',');
                dimensionsH = parseInt(dimensions[1]);
                scaledHeight = dimensionsH * scale;
            }
            console.log('scale', scale, scaledHeight)
            $el.css({
                transform: "translate(-50%, 0) " + "scale(" + scale + ")",
                height: scaledHeight
            });
        }

        var starterData = { 
            size: {
                width: $wrapper.width(),
                height: $wrapper.height()
            }
        }
        
        doResize(null, starterData);
        $window.resize(function(event){
            console.log('resize-----------')
            var resizedData = { 
                size: {
                    width: $wrapper.width(),
                    height: $wrapper.height()
                }
            }
            doResize(event,resizedData)
        });

        
        /* ------------- hcp modal ----------------- */

        var patientURL = 'http://fotivda.com';
        var patientStgURL = 'http://18.116.52.56/';
        var patientLocalURL = "http://fotivda/";

        var hcpURL = 'fotivdahcp.com';
        var hcpStgURL = "44.198.60.39";
        var hcpLocalURL = "fotivdahcp";

        var hcpModal = new understrap.Modal(document.getElementById('hcpModal'), {});

        // check if user is a bot (for analytics)
        function isBot() {
            // List of common bot user agents
            var botUserAgents = [
                'googlebot', 'bingbot', 'slurp', 'duckduckbot', 'baiduspider', 'yandexbot', 'sogou', 'exabot', 'facebot', 'ia_archiver'
            ];
            
            var userAgent = navigator.userAgent.toLowerCase();
            
            for (var i = 0; i < botUserAgents.length; i++) {
                if (userAgent.indexOf(botUserAgents[i]) !== -1) {
                    return true;
                }
            }
            
            return false;
        }

        if ((window.location.hostname.includes(hcpURL) || window.location.hostname.includes(hcpStgURL) || window.location.hostname.includes(hcpLocalURL)) && localStorage.getItem('for-hcp') === null && isBot() === false) {
            hcpModal.show();
        }
        e('#for-hcp-ok').on('click', function () {
            e('#hcpModal').modal('hide');
            localStorage.setItem('for-hcp', true);
        });
        e('#for-hcp-cancel').on('click', function () {
            if ((window.location.hostname.includes(hcpURL) )){
                window.location.assign(patientURL);
            }
            if ((window.location.hostname.includes(hcpStgURL) )){
                window.location.assign(patientStgURL);
            }
            if ((window.location.hostname === hcpLocalURL )){
                window.location.assign(patientLocalURL);
            }
        });

        /* ------------- npi form ----------------- */
        

        if(e('#npi-search-form').length>0){
            function formDisableToggle(state){
                var $form = e('.form-disabled');
                $form[state ? 'removeClass' : 'addClass']('DISABLED');
                e('.form-disabled input, .form-disabled button').each(function(){
                    var $element = e(this);
                    if(state){
                        $element.removeAttr('disabled');
                    }else{
                        $element.attr('disabled', 'disabled');
                    }
                });
            }
            formDisableToggle(false);

            console.log('NPI FORM --------');
            var rarForm = e('#wpforms-form-284'); // request a rep
            var rarFormContainer = e('#wpforms-284');
            var rarForm_npiInput = e('.npi_number'); // rar form npi input field
            // rarForm.hide();
            // rarForm_npiInput.hide();

            var apiUrl = '/wp-json/custom/v1/npinumber/';
            var npiForm = e('#npi-search-form');
            var npiFormInput = e('#npi-input'); // find info by npi
            var npiFormInputContainer = e('#npi-search-form .wpforms-field.wpforms-field-text');
            var npiFormSubmitBtn = e('.npi-submit-btn')[0];
            var npiInputVal = '';

            var errorLabelInvalid = '<label class="wpforms-error npi-error">Please enter a 10-digit NPI number.</label>';
            var errorLabelNoResult = '<label class="wpforms-error npi-error">No result. Please enter a valid NPI number.</label>';
            

            // allow confirmation message to show if succeful submission
            if(e('.wpforms-confirmation-container-full').length>0){
                rarFormContainer.removeClass('d-none');
                npiForm.addClass('d-none');
                e('.npi-content').addClass('d-none');
            }

            
            // restrict input
            npiFormInput.on('input', function(event){
                // Remove any non-numeric characters from the input
                this.value = this.value.replace(/[^0-9]/g, "");

                // Limit the input to 10 digits
                if (this.value.length > 10) {
                    this.value = this.value.slice(0, 10);
                }
            });
    
            npiForm.on('submit', function(event){

                event.preventDefault();

                var errorLabel = document.querySelector('.npi-error');
                if(errorLabel) {
                    console.log('errorLabel', errorLabel)
                    errorLabel.remove();
                    npiFormInput[0].style.border = 'none';
                }

                var validInput = npiFormInput[0].value.length === 10;

                if (!validInput) {
                    npiFormInput[0].style.border = '1px solid #cc0000';
                    npiFormInputContainer.append(errorLabelInvalid);
                } else {
                    npiFormSubmitBtn.innerText = "Searching..."
                    npiInputVal = npiFormInput[0].value;
                    // console.log('NPI-FORM--value', npiInputVal);

                    // console.log('RAR FORM', rarForm[0]);

                    jQuery.ajax({
                        url: apiUrl + '?number=' + npiInputVal,
                        type: 'GET',
                        dataType: 'json',
                        success: function(data) {
                            var result = JSON.parse(data);
                            // console.log('API Result --------', result);

                            if(result && result.result_count===0){ // valid input returns empty object
                                npiFormInput[0].style.border = '1px solid #cc0000';
                                npiFormInputContainer.append(errorLabelNoResult);
                                npiFormSubmitBtn.innerText = "Search";
                            } else {
                                // console.log('NPI DATA --------', result.results[0]);
                                var results = result.results[0];
                                var extractedResults = {};
                                extractedResults.first_name = results.basic.first_name;
                                extractedResults.last_name = results.basic.last_name;
                                for (var i = 0; i < results.addresses.length; i++) {
                                    if (results.addresses[i].address_purpose === "LOCATION") {
                                        extractedResults.address_line_1 = results.addresses[i].address_1;
                                        if(results.addresses[i].address_2){
                                        extractedResults.address_line_2 = results.addresses[i].address_2;
                                        }
                                        extractedResults.city = results.addresses[i].city;
                                        extractedResults.state = results.addresses[i].state;
                                        extractedResults.zip_code = results.addresses[i].postal_code;
                                        break;
                                    }
                                };

                                if (results.addresses[0].telephone_number) {
                                    extractedResults.phone = results.addresses[0].telephone_number;
                                };

                                // console.log('*********EXTRACTED RESULTS', extractedResults);

                                // Assign the extracted values to the matching form fields
                                for (var prop in extractedResults) {
                                    if (extractedResults.hasOwnProperty(prop)) {
                                        var className = '.' + prop; // Create class name string based on property name
                                        var inputField = e(className + ' input')[0]; // Find the input field within the div wrapper
                                        var value = extractedResults[prop];
                                        if (inputField) {
                                            inputField.value = value;
                                        }
                                    }
                                }

                                // add npi number to form
                                e('.npi_number input')[0].value = npiInputVal;

                                npiFormSubmitBtn.innerText = "Search";
                                rarFormContainer.removeClass('d-none');
                                var formEl = document.querySelector('#wpforms-form-284');
                                formEl && formEl.scrollIntoView({ behavior: 'auto' });

                                formDisableToggle(true);
                            };
                        },
                        error: function(xhr, status, error) {
                            console.error('Error:', error);
                        },
                    });
                }
                
            });

            // email feedback is not last child, opposite of all other inputs? // ensure it is last child
            rarForm.on('submit', function(){
                e('#wpforms-284-field_11-error').parent().append(e('#wpforms-284-field_11-error'));
            });

            // check for npi parameter // if present auto search
            var currentURL = window.location.href;
            var url = new URL(currentURL);
            var npiValue = url.searchParams.get("npi");
            var emailValue = url.searchParams.get("connect");

            // set email field
            console.log('emailValue',emailValue)
            if (emailValue) {
                var emailField = e('.wpforms-field-email input')[0];
                var decodedEmail = atob(emailValue);
                emailField && (emailField.value = decodedEmail);
            }
            if (npiValue !== null) {
                npiFormInput[0].value = npiValue;
                npiForm.trigger('submit');

                //scroll to the recapta
                if(currentURL.includes('request-a-rep-npi')){
                    // var npiAnchor = document.querySelector('.wpforms-recaptcha-container');
                    var npiAnchor = document.querySelector('#wpforms-form-2298.wpforms-form');
                    setTimeout(function(){
                        npiAnchor && npiAnchor.scrollIntoView({ behavior: 'instant' });
                    }, 0);
                }
                
            }
        }

        // 1023403292
        // 1982057170

        // http://fotivdahcp/wp-json/custom/v1/npinumber/?number=1023403292


    })(jQuery);

});


// var lightboxOverlay = document.querySelector('.wp-lightbox-overlay.zoom.active');
// lightboxOverlay.style.visibility = "hidden";

// var lightboxOverlays = document.querySelectorAll('.wp-lightbox-overlay');
// var lightboxTriggers = document.querySelectorAll('.lightbox-trigger');
// var wpImages = document.querySelectorAll('.wp-block-image');

// for (var i = 0; i < lightboxOverlays.length; i++) {
//     lightboxOverlays[i].style.opacity = '0';
//     // setTimeout(function() {
//     //     lightboxOverlays[i].style.opacity = '1';
//     // }, 500);
// }

// lightboxTriggers.forEach(function(trigger) {
//     trigger.addEventListener('click', function() {
//         var overlays = document.querySelectorAll('.wp-lightbox-overlay');
//         overlays.forEach(function(overlay) {
//             overlay.style.opacity = '1';
//         });
//     });
// });

// wpImages.forEach(function(img) {
//     img.addEventListener('click', function() {
//         var overlays = document.querySelectorAll('.wp-lightbox-overlay');
//         overlays.forEach(function(overlay) {
//             overlay.style.opacity = '1';
//         });
//     });
// });


function removePlayerProgressKeys() {
    var localStorageKeys = Object.keys(localStorage);
    
    localStorageKeys.forEach(function (key) {
      if (key.includes('player-progress')) localStorage.removeItem(key);
    });
};

function timeRangeToSeconds(range) {
    var startEnd = range.split('-');
    var startStr = startEnd[0];
    var endStr = startEnd[1];
  
    function convertToSeconds(timeStr) {
      var minutesSeconds = timeStr.split(':').map(Number);
      var minutes = minutesSeconds[0];
      var seconds = minutesSeconds[1];
      return minutes * 60 + seconds;
    }
  
    var start = convertToSeconds(startStr);
    var end = convertToSeconds(endStr);

    return { start: start, end: end };
};

var timestamps = {
    'video-chapter--topic-1': timeRangeToSeconds('0:10-1:59'),
    'video-chapter--topic-2': timeRangeToSeconds('2:00-3:03'),
    'video-chapter--topic-3': timeRangeToSeconds('6:01-10:03'),
    'video-chapter--topic-4': timeRangeToSeconds('10:03-10:58'),
    'video-chapter--topic-5': timeRangeToSeconds('3:50-4:37'),
    'video-chapter--topic-6': timeRangeToSeconds('4:38-5:59'),
    'video-chapter--topic-7': timeRangeToSeconds('7:04-8:23'),
    'video-chapter--topic-8': timeRangeToSeconds('11:00-13:26'),
    'video-chapter--topic-nccn': timeRangeToSeconds('3:04-17:01'),
};

// topics to remove overlay play button due to poster with text
var textPosterVideos = [
    'video-chapter--topic-1',
    'video-chapter--topic-2',
    'video-chapter--topic-3',
    'video-chapter--topic-4',
    'video-chapter--topic-5',
    'video-chapter--topic-8'
];

// chaptered videos
function handleChapteredVideo (readyPlayer) {
    console.log('checkForVideo');

    // chaptered video classes are placed on the presto reusable block container
    var videoWrappers = document.querySelectorAll('.wp-block-presto-player-reusable-edit.chaptered-video');
    var allChaptersVideoWrappers = document.querySelectorAll('.chaptered-video--all-chapters');
    console.log('videoWrappers',videoWrappers.length, videoWrappers);
    console.log('allChaptersVideoWrappers',allChaptersVideoWrappers.length, allChaptersVideoWrappers);

    if (videoWrappers.length) {
        videoWrappers.forEach(function (videoWrapper) {

            var video = videoWrapper && videoWrapper.querySelector('presto-player');
            console.log('video', video);

            if (video) {
                console.log('-- found video');

                var wasPlaying = false;
                var userContinued = false;
                var currentTopic = '';
                var activePlayerId = 0;
                var isChapteredVideo = false;
                
                // set video topic class as current topic
                for (var topic in timestamps) {
                    if (timestamps.hasOwnProperty(topic) && videoWrapper.classList.contains(topic)) {
                        currentTopic = topic;
                        break;
                    }
                };
    
                if (currentTopic && wp.hooks) {

                    // remove play button if topic has a poster with text
                    if(textPosterVideos.includes(currentTopic)){
                        var overlaidPlayBtn = video.shadowRoot.querySelector('.plyr__control.plyr__control--overlaid');
                        overlaidPlayBtn.style.display = 'none';
                    }

                    // readyPlayer.currentTime = timestamps[currentTopic].start;
                    // console.log('READY PLAYER current time', timestamps[currentTopic].start, readyPlayer.currentTime);
                    // check if active player is a chaptered video
                    // if true and first time playing, start at timestamped start time
                    wp.hooks.addAction("presto.playerPlay", "my-plugin-namespace", function (player) {
                        console.log('player', player);
                        console.log('activeElement---', player.elements.original.ownerDocument.activeElement.id);
                        console.log('video.id---', video.id);
                        activePlayerId = player.elements.original.ownerDocument.activeElement.id;
                        isChapteredVideo = video.id === activePlayerId;
                        console.log('isChapteredVideo ?', isChapteredVideo);
                        if (isChapteredVideo && !wasPlaying && !userContinued) {
                            player.currentTime = timestamps[currentTopic].start;
                            wasPlaying = true;
                        };
                    });
                    // pause if video meets or exceeds timestamped end time, unless user manually continues playback
                    wp.hooks.addAction("presto.playerTimeUpdate", "my-plugin-namespace", function (player) {
                        if (isChapteredVideo && player.currentTime >= timestamps[currentTopic].end && !userContinued && wasPlaying) {
                            player.pause();
                            userContinued = true;
                            
                        };
                    });

                    wp.hooks.addAction("presto.playerPause", "my-plugin-namespace", function (player) {
                        isPlaying = false;
                        console.log('paused');
                        // console.log('readyPlayer.currentTime', readyPlayer.currentTime);
                    });
                };

            } else {
                console.log('-- no video');
            };
        });
    };

    if(allChaptersVideoWrappers) {
        allChaptersVideoWrappers.forEach(function (videoWrapper) {
            var video = videoWrapper && videoWrapper.querySelector('presto-player');
            console.log('video', video);

            if (video) {
                console.log('-- found video');

                var playerObj = new Plyr(video);
                console.log('PLYR-OBJECT', playerObj);
                
                var isPlaying = false;
                var wasPlaying = false;
                var userContinued = false;
                var currentTopic = '';
                var activePlayerId = 0;
                var isChapteredVideo = false;
                
                // listen for click to set currentTopic
                document.querySelectorAll('.chapter-link').forEach(function(chapterLink) {
                    chapterLink.addEventListener('click', function() {
                        if(isPlaying) {
                            console.log('isPlaying');
                            video.pause();
                        };
                        document.querySelectorAll('.chapter-link').forEach(function(link) {
                            link.classList.remove('chapter-link--clicked');
                            if(link.id === chapterLink.id){
                                chapterLink.classList.add('chapter-link--clicked');
                            }
                        });
                        // Set currentTopic based on clicked element's class
                        for (var topic in timestamps) {
                            if (timestamps.hasOwnProperty(topic) && chapterLink.classList.contains(topic)) {
                                currentTopic = topic;
                                console.log('currentTopic-eventListenr', currentTopic);
                                playerObj.play();
                                break;
                            }
                        };
                    })
                });
    
                wp.hooks.addAction("presto.playerPlay", "my-plugin-namespace", function (player) {
                    isPlaying = true;
                    console.log('player', player);
                    console.log('activeElement---', playerObj.media.id);
                    console.log('video.id---', video.id);
                    activePlayerId = playerObj.media.id;
                    isChapteredVideo = video.id === activePlayerId;
                    console.log('isChapteredVideo ?', isChapteredVideo);


                    if (isChapteredVideo && !wasPlaying && !userContinued) {
                        console.log('currentTopic-hook', currentTopic);
                        player.currentTime = timestamps[currentTopic].start;
                        // wasPlaying = true;
                    };
                });

                wp.hooks.addAction("presto.playerPause", "my-plugin-namespace", function (player) {
                    isPlaying = false;
                    console.log('paused');
                });

            } else {
                console.log('-- no video');
            };
        });
    }
};

removePlayerProgressKeys();

function lumPauseAllVideos() {
    for (var key in lumPlayersObj) {
        lumPlayersObj[key].pause();
    }
}

var lumPlayersObj = {};
var lumPlayersArr = [];
wp.hooks && wp.hooks.addAction("presto.playerReady", "my-plugin-namespace", function (player) {
    var idValue = player.id;
    console.log('player READY', player, idValue);
    if(!lumPlayersObj[idValue]){
        lumPlayersObj[idValue] = player;
        lumPlayersArr.push(player);

        // all videos are ready
        var videoWrappers = document.querySelectorAll('.presto-block-video');
        if(lumPlayersArr.length === videoWrappers.length){
            // console.log('innnnnnnnnnn', lumPlayersArr.length,' === ',videoWrappers.length)
            var puOpen = document.querySelectorAll('.pum-trigger');
            var puClose = document.querySelectorAll('.pum-close');
            if(puOpen) {
                puOpen.forEach(function (puOpenBtn){
                    puOpenBtn.addEventListener("click", function() {
                        // e(video.id).remove();
                        // player.pause();
                        lumPauseAllVideos();
                        console.log('popup open clicked');
                    });
                });
            };
            if(puClose) {
                puClose.forEach(function (puCloseBtn) {
                    puCloseBtn.addEventListener("click", function() {
                        // e(video.id).remove();
                        // player.pause();
                        lumPauseAllVideos()
                        console.log('popup close clicked');
                    });
                })
            };
            setTimeout(function(){
                handleChapteredVideo(player);
            },100);
        }
    }
});


// var hcpURL = 'https://www.fotivdahcp.com';
// var patientURL = 'https://www.fotivda.com';

// if(window.location.origin=='https://fotivdahcp_v2.guidemarkhealth.com'){
//     hcpURL = 'https://fotivdahcp_v2.guidemarkhealth.com';
// }else if(window.location.origin=='http://44.198.60.39'){
//     hcpURL = 'http://44.198.60.39';
// }else if(window.location.origin=='http://fotivdahcp'){
//     hcpURL = 'http://fotivdahcp';
// }

// if(window.location.hash==="#b"){
//     window.location.hash = ''; 
//     sessionStorage.setItem('branch', (window.location.origin===hcpURL ? 'hcp': 'patient'));
// }

